const runtimeConfig = () => {
  if (typeof window === "undefined") {
    return {};
  }

  return window.__RUNTIME_CONFIG__ ?? {};
};

const firstNonEmpty = (...values) => {
  for (const value of values) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  return "";
};

export const getAdyenApiBaseUrl = () => {
  return firstNonEmpty(
    runtimeConfig().ADYEN_API_BASE_URL,
    process.env.REACT_APP_ADYEN_API_BASE_URL,
    "http://70.35.194.208:5000",
  );
};

export const getAdyenClientKey = (sessionClientKey) => {
  return firstNonEmpty(
    sessionClientKey,
    runtimeConfig().ADYEN_CLIENT_KEY,
    process.env.REACT_APP_ADYEN_CLIENT_KEY,
  );
};

export const getAdyenGooglePayMerchantId = () => {
  return firstNonEmpty(
    runtimeConfig().ADYEN_GOOGLE_PAY_MERCHANT_ID,
    process.env.REACT_APP_ADYEN_GOOGLE_PAY_MERCHANT_ID,
    process.env.REACT_APP_FORWARD_GOOGLE_PAY_MERCHANT_ID,
  );
};

// Live Google Pay rejects localhost. Use the registered checkout origin instead.
export const getAdyenGooglePayMerchantOrigin = () => {
  if (typeof window !== "undefined" && !isLocalHost(window.location.hostname)) {
    return window.location.origin;
  }

  return toOrigin(
    firstNonEmpty(
      runtimeConfig().ADYEN_GOOGLE_PAY_MERCHANT_ORIGIN,
      process.env.REACT_APP_ADYEN_GOOGLE_PAY_MERCHANT_ORIGIN,
      runtimeConfig().ADYEN_RETURN_ORIGIN,
      process.env.REACT_APP_ADYEN_RETURN_ORIGIN,
      "https://secure.pos.orders.co",
    ),
  );
};

const isLocalHost = (hostname) =>
  hostname === "localhost" || hostname === "127.0.0.1";

const isRunningOnLocalhost = () =>
  typeof window !== "undefined" && isLocalHost(window.location.hostname);

export const getAdyenEnvironment = (sessionEnvironment) => {
  const raw = firstNonEmpty(
    sessionEnvironment,
    runtimeConfig().ADYEN_ENVIRONMENT,
    process.env.REACT_APP_ADYEN_ENVIRONMENT,
    "test",
  );

  return raw.toLowerCase() === "live" ? "live" : "test";
};

// Live client keys reject http://localhost. On a local dev server, point
// Checkout at the same-origin proxy so card fields and API calls share one origin.
export const getLocalAdyenEnvironmentUrls = (environment) => {
  if (!isRunningOnLocalhost()) {
    return null;
  }

  const origin = window.location.origin;
  // CSF only accepts iframe postMessage when loadingContext is
  // `{origin}/checkoutshopper/`. Keep that exact path on localhost.
  if (environment === "live") {
    return {
      api: `${origin}/checkoutshopper/`,
      analytics: `${origin}/checkoutanalytics-live/`,
    };
  }

  return {
    api: `${origin}/checkoutshopper/`,
    analytics: `${origin}/checkoutanalytics-test/`,
  };
};

const ADYEN_REDIRECT_PARAMS = new Set([
  "redirectResult",
  "sessionId",
  "sessionResult",
  "payload",
]);

const toOrigin = (value) => {
  if (!value) {
    return "";
  }

  try {
    const url = value.includes("://") ? new URL(value) : new URL(`https://${value}`);
    return url.origin;
  } catch {
    return "";
  }
};

export const getAdyenReturnOrigin = () => {
  const configured = toOrigin(
    firstNonEmpty(
      runtimeConfig().ADYEN_RETURN_ORIGIN,
      process.env.REACT_APP_ADYEN_RETURN_ORIGIN,
    ),
  );

  if (typeof window !== "undefined") {
    if (
      configured &&
      new URL(configured).hostname === window.location.hostname
    ) {
      return configured;
    }
    return window.location.origin;
  }

  return configured || "https://secure.pos.orders.co";
};

export const getAdyenReturnUrl = () => {
  const origin = getAdyenReturnOrigin();
  const next = new URL(origin);
  const source =
    typeof window !== "undefined" ? new URL(window.location.href) : next;

  next.pathname = source.pathname || "/";
  source.searchParams.forEach((value, key) => {
    if (!ADYEN_REDIRECT_PARAMS.has(key)) {
      next.searchParams.set(key, value);
    }
  });

  return next.toString();
};
